import { SWReactIcons } from "@similarweb/icons";
import { colorsPalettes } from "@similarweb/styles";
import { Text } from "@similarweb/ui-components/foundations";

import { translate } from "app/filters/i18nFilter";

import { StyledContactBaseInfoStack } from "./styles";

const ContactBaseInfoEmptyState = () => {
    return (
        <StyledContactBaseInfoStack
            alignItems="center"
            justifyContent="center"
            data-automation="top-companies.contact-empty-state"
            gap="8px"
        >
            <SWReactIcons
                iconName="search-purple"
                size="48px"
            />

            <Text
                fontVariant="caption"
                color={colorsPalettes.carbon[300]}
            >
                {translate("si.top-companies.contact-details.empty-text")}
            </Text>
        </StyledContactBaseInfoStack>
    );
};

export default ContactBaseInfoEmptyState;
